type DisplayType = 'language' | 'region'

const LOCALE_MAP: { [key: string]: string } = {
  pt: 'pt',
  en: 'en',
  es: 'es',
  it: 'it',
}

export function getDisplayName(
  code: string,
  displayLocale: string,
  type: DisplayType = 'language',
): string {
  const normalizedCode = LOCALE_MAP[code] || code
  const normalizedDisplayLocale = LOCALE_MAP[displayLocale] || displayLocale

  const intl = new Intl.DisplayNames([normalizedDisplayLocale], { type })
  return intl.of(normalizedCode) || code
}
